import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

/**
 * Whether the current community lets members switch away from it.
 *
 * Not the same as the `display_community_switcher` backend prop, which is also
 * true when an admin only needs the switcher rail to reach Circle AI.
 */
export const useCanSwitchCommunities = (): boolean => {
  const { currentCommunity } = usePunditUserContext();

  return Boolean(currentCommunity?.community_switcher_enabled);
};
